/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./quote.module.css";
import Loader from "../../../component/loader";
import { Routes, Route } from "react-router-dom";
import Button from "../../../component/button";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import constants from "../../../helper/constants";
import BusApiCall from "../../../helper/axios";
import CustomerDetailsBlock from "../checkout/review/customerDetailsBlock";
import NewCartBlock from "../checkout/review/newCartBlock";
import Input from "../../../component/inputpm";
import TableContainer from "@mui/material/TableContainer";
import formatDate from "../../../helper/dateFormatter";

// Quote view page parent class
class Quote extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [],
    id: "",
    status: "",
    loading: true,
    quoteData: [],
    customerDetails: {},
    comments: [],
    render: false,
    notes: "",
    showActionButtons: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    var id = this.props.router.params.id;
    let bread = [
      { title: this.props.t("QUOTES"), url: "/quotes" },
      {
        title: this.props.router.params.id,
        url: `/quote/${this.props.router.params.id}`,
      },
    ];
    this.setState(
      {
        id,
        bread,
      },
      () => {
        this.getQuoteData();
      },
    );
  }

  getQuoteData = () => {
    BusApiCall("GET", `${constants.busV44UrlPublic}/quote/${this.state.id}`)
      .then((res) => {
        console.log("check quote data", res.data);
        if (res.data && res.data.length > 0) {
          this.setState({
            quoteData: res.data,
            status: res.data[0].quoteStatus,
            customerDetails: res.data[0].customer,
            comments: res.data[0].comments,
            loading: false,
            render: true,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  setQuoteStatus = (id) => {
    switch (id) {
      case id === "QUO_REVIEW":
        return this.props.t("QUOTE_SUBMITTED_FOR_REVIEW");
      case id === "QUO_CREATED":
        return this.props.t("QUOTE_CREATED");
      case id === "QUO_APPROVED":
        return this.props.t("QUOTE_APPROVED");
      case id === "QUO_REJECTED":
        return this.props.t("QUOTE_REJECTED");
      default:
        return id;
    }
  };

  verifyQuote = (status) => {
    // this.setState({
    //     loading: true
    // })
    // var payload = {
    //     statusId: status,
    //     note: {
    //         text: this.state.notes
    //     }
    // };
    // BusApiCall('PUT', `${constants.busV44UrlPublic}/quote/${this.state.id}/updateStatus`, payload).then(res => {
    //     this.props.setErrorMessage(this.props.t('QUOTE_STATUS_UPDATED'), true)
    //     this.setState({
    //         loading: false,
    //         showActionButtons: false
    //     })
    //     this.getQuoteData(this.state.id);
    // }).catch(err => {
    //     if (err.response && err.response.data && err.response.data.message) {
    //         this.props.setErrorMessage(err.response.data.message, false)
    //     } else {
    //         this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
    //     }
    //     this.setState({
    //         loading: false,
    //     })
    // })
  };

  changeNotes = (e) => {
    this.setState({
      notes: e.target.value,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
                <div className={"bottomBreadcrumbText"}>
                  <h2 className={classes.orderHeaderInfo}>
                    {`Order #${this.props.router.params.id}`}
                    <b>{`Status : ${this.props.t(this.state.status)}`}</b>
                  </h2>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          {this.state.render && (
            <>
              <CustomerDetailsBlock
                editOption={false}
                stage={{}}
                edit={() => {}}
                customerDetails={this.state.customerDetails}
              />
              <div style={{ marginTop: "25px" }}>
                <NewCartBlock
                  cartData={this.state.quoteData}
                  // removePSFromCart={removePSFromCart}
                  // changeQuantity={changePSQuantity}
                  edit={{}}
                  providerType={this.props.providerType}
                  loggedInUserType={this.props.loggedInUserType}
                />
              </div>
              {this.state.comments && this.state.comments.length > 0 && (
                <div style={{ margin: "25px 0" }}>
                  <TableContainer>
                    <Table className={"newGlobalTable"}>
                      <TableHead>
                        <TableRow>
                          <TableCell>{this.props.t("DATE")}</TableCell>
                          <TableCell style={{ width: "60%" }}>
                            {this.props.t("COMMENT")}
                          </TableCell>
                          <TableCell>{this.props.t("BY")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.comments.map((comment) => (
                          <TableRow>
                            <TableCell>
                              {formatDate(comment.dateTime)}
                            </TableCell>
                            <TableCell>{comment.text}</TableCell>
                            <TableCell>{comment.addedBy}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
              {this.state.showActionButtons && (
                <>
                  <div style={{ margin: "25px 0" }}>
                    <Input
                      size={"small"}
                      name={"notes"}
                      variant={"outlined"}
                      placeholder={this.props.t("NOTES") + "......."}
                      //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                      value={this.state.notes}
                      onChange={this.changeNotes}
                      //inputProps={{ rows: "5", cols: "10", disabled: true }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        cols: 10,
                        disabled: false,
                      }}
                    />
                  </div>
                  <div align="right" style={{ margin: "25px 0" }}>
                    <Button
                      onClick={() => {
                        this.verifyQuote("QUO_REJECTED");
                      }}
                      style={{ marginRight: "15px" }}
                    >
                      {this.props.t("REJECT")}
                    </Button>
                    <Button
                      onClick={() => {
                        this.verifyQuote("QUO_APPROVED");
                      }}
                    >
                      {this.props.t("APPROVE")}
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </main>
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    userPerms: state.auth.userPerms,
    menuPaths: state.auth.menuPaths,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Quote));
